/* eslint-disable react/no-array-index-key */
import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import { useTheme } from '@components/theme';
import breakpoints from '@constants/breakpoints';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import { hashCode, substringAfterLast } from '@lib/string';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';
import { IFooterImages } from './formatShopSuggestions';
import styles from './ShopSuggestions.module.scss';

interface IShopSuggestionsProps {
  className?: string;
  footerImages: IFooterImages[];
}

const getSuggestions = (list: IFooterImages[]): IFooterImages[] => {
  return list.filter((el) => el.image?.url).sort(() => 0.5 - Math.random()).slice(0, 2);
};

const ShopSuggestions = ({
  className = '',
  footerImages
}: IShopSuggestionsProps) => {
  const theme = useTheme();

  if (footerImages?.length === 0) {
    return null;
  }

  const router = useRouter();

  const slug = substringAfterLast(router.asPath, '/');
  const filteredList = footerImages.filter((data) => !data.ctalink.url.includes(slug));
  const images = getSuggestions(filteredList);

  return (
    <div className={classNames(className, styles.ShopSuggestions)}>
      {images.length > 0 && images.map(({ ctalink, ctaLabel, image }) => {
        return (
          <div key={hashCode(image.url)} className={styles.Container}>
            <div className={styles.ImageWrapper}>
              <PrismicImage
                className={styles.Image}
                image={image}
                breakpoints={{
                  mobile: breakpoints.desktop
                }}
                lazy={false}
                noAspectRatioBox
              />
            </div>
            <a
              role="button"
              href={ctalink.url}
              className={classNames(
                theme.styles.Button,
                theme.styles.Conflicting,
                theme.styles.Small,
                styles.CTA
              )}
              onClick={() => {
                analyticsTrack('cta_clicked', {
                  title: `Shop Category Page | Shop Suggestions`,
                  ctaLabel,
                  ctaUrl: ctalink.url,
                  image
                });
              }}
            >
              {ctaLabel}
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default ShopSuggestions;
